import { render } from "./NoAccess.vue?vue&type=template&id=af6b70b6&ts=true"
import script from "./NoAccess.vue?vue&type=script&lang=ts"
export * from "./NoAccess.vue?vue&type=script&lang=ts"

import "./NoAccess.vue?vue&type=style&index=0&id=af6b70b6&lang=scss"

import exportComponent from "/codebuild/output/src2155066187/src/reference-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__